const products = [
  {
    _id: "1",
    name: "Large Cluster Pendant",
    price: 100.0,
    description:
      "A hoop earring with an accumulation of rows referring to the collection rings, easy to wear on a daily basis",
    brand: "nola",
    category: "lamp",
    height: 20,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.unsplash.com/photo-1581784878214-8d5596b98a01?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80",
    ArtNum: 128364,
    countInStock: 6,
    delivery: 5,

    collection: "nubi",
  },
  {
    _id: "2",
    name: "Zephi ring",
    price: 100.0,
    description:
      "A hoop earring with an accumulation of rows referring to the collection rings, easy to wear on a daily basis",
    brand: "nola",
    category: "furniture",
    height: 20,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.unsplash.com/photo-1551298213-de5c034f5d50?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80",
    ArtNum: 128364,
    countInStock: 6,
    delivery: 5,

    collection: "nubi",
  },
  {
    _id: "3",
    name: "Large Cluster Pendant",
    price: 100.0,
    description:
      "A hoop earring with an accumulation of rows referring to the collection rings, easy to wear on a daily basis",
    brand: "nola",
    category: "lighting",
    height: 20,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.unsplash.com/photo-1581783458534-001a466b5487?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80",
    ArtNum: 1248364,
    countInStock: 6,
    delivery: 5,

    collection: "nubi",
  },
  //
  //
  //-----------------
  // glassware
  //-----------------
  {
    _id: "4",
    name: "Carafe",
    price: 35.0,
    description: "Carafe in clear glass. Diameter at top 2 3/4 in.",
    brand: "humlo",
    category: "glass",
    height: 20,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/8145719/pexels-photo-8145719.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 284364,
    countInStock: 6,
    delivery: 5,

    collection: "norla",
  },
  {
    _id: "5",
    name: "Beverage Glass",
    price: 15.0,
    description: "Beverage glass | Diameter at top 3 1/4 in",
    brand: "humlo",
    category: "glass",
    height: 20,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/8145720/pexels-photo-8145720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 2284364,
    countInStock: 6,
    delivery: 5,

    collection: "norla",
  },
  {
    _id: "6",
    name: "Carafe",
    price: 30.0,
    description: "Carafe in clear glass. Diameter at top 2 3/4 in.",
    brand: "humlo",
    category: "glass",
    height: 20,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/8145715/pexels-photo-8145715.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 2284364,
    countInStock: 6,
    delivery: 5,

    collection: "norla",
  },
  {
    _id: "7",
    name: "Beverage Glass",
    price: 100.0,
    description: "Beverage glass | Diameter at top 3 1/4 in",
    brand: "humlo",
    category: "glass",
    height: 16.0,
    width: 45,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/8145718/pexels-photo-8145718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 2284364,
    countInStock: 6,
    delivery: 5,

    collection: "norla",
  },
  //
  //
  //-----------------
  // CUPS & MUGS bowls
  //-----------------
  {
    _id: "8",
    name: "Teak Wooden Bowl",
    price: 49.0,
    description:
      "The wooden bowl by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "bowl",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/6569019/pexels-photo-6569019.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,

    collection: "borlani",
  },
  {
    _id: "9",
    name: "Teak Wooden Bowl",
    price: 49.0,
    description:
      "The wooden bowl by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "plate",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/6569148/pexels-photo-6569148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,

    collection: "borlani",
  },
  {
    _id: "10",
    name: "Stone Plate",
    price: 49.0,
    description:
      "The Stone plate by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "bowl",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/6569285/pexels-photo-6569285.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,

    collection: "borlani",
  },
  {
    _id: "11",
    name: "Stone Plate",
    price: 49.0,
    description:
      "The Stone plate by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "plate",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/6569303/pexels-photo-6569303.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,

    collection: "borlani",
  },
  //
  //
  //-----------------
  // furniture
  //-----------------
  {
    _id: "12",
    name: "desktop tek",
    price: 350.0,
    description:
      "The wooden bowl by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "desktop",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/11112745/pexels-photo-11112745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,
    collection: "boreal",
  },
  {
    _id: "13",
    name: "armchair",
    price: 300.0,
    description:
      "The wooden bowl by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "armchair",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "  https://images.pexels.com/photos/11112735/pexels-photo-11112735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,
    collection: "boreal",
  },
  {
    _id: "14",
    name: "Chair",
    price: 300.0,
    description:
      "The wooden bowl by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "chair",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/11112732/pexels-photo-11112732.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,
    collection: "boreal",
  },
  {
    _id: "15",
    name: "Table",
    price: 300.0,
    description:
      "The wooden bowl by humlo is practical for storing fruit or serving salads. The bowl is made by hand",
    brand: "humlo",
    category: "table",
    height: 30,
    width: 10,
    depth: 45,
    weight: 260,
    image:
      "https://images.pexels.com/photos/11112739/pexels-photo-11112739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ArtNum: 3284364,
    countInStock: 6,
    delivery: 5,
    collection: "boreal",
  },
];

export default products;
